// Mirrors backend enum InAppNotificationPriority; generated TS enum is broken (see api/model/inAppNotificationPriority.ts)
export enum InAppNotificationPriority {
  Information = 0,
  Important = 1,
  Critical = 2,
  Maintenance = 3,
}
